<template>
  <!-- 非作答区域弹框 -->
  <el-dialog
    title="非作答区域"
    width="500px"
    class="dialog"
    :visible="value"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('input', false)"
    append-to-body
  >
    <el-form inline :model="formData" :rules="rulesFrom" ref="formData">
      <el-form-item label="区域高度：" prop="height">
        <el-input-number
          v-model="formData.height"
          size="small"
          :min="1"
          :max="200"
          :step="1"
          controls-position="right"
          style="width: 200px"
        ></el-input-number>
        <span>px</span>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { nonAnswerAreaModel } from "./nonAnswerArea.model.js";
import { mapState } from "vuex";

export default {
  name: "nonAnswerArea",
  props: ["value","subject"],
  computed: {
    ...mapState("card", {
    }),
  },
  data() {
    return {
      formData: new nonAnswerAreaModel(),
      rulesFrom: {
        height: [
          { required: true, message: "请设置区域高度", trigger: "blur" },
          { type: 'number', message: '高度必须为数字', trigger: 'blur' }
        ],
        description: [
          { max: 20, message: '描述不能超过20个字符', trigger: 'blur' }
        ]
      },
      submitDisabled: false
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          // 重置表单数据
          this.formData = new nonAnswerAreaModel();
          this.$nextTick(() => {
            this.$refs.formData.clearValidate();
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    dialogClose() {
      this.$emit("input", false);
    },
    
    dialogSubmit() {
      if (this.submitDisabled) {
        return false;
      }
      this.submitDisabled = true;
      
      // 添加防抖处理
      let timer = setTimeout(() => {
        this.submitDisabled = false;
        clearTimeout(timer);
      }, 500);
      
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          // 创建一个新的非作答区域实例
          const nonResponseArea = new nonAnswerAreaModel(this.formData);
          this.$emit("submit-nonAnswer", nonResponseArea);
          this.$emit("input", false);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dialog {
  .el-form-item {
    margin-bottom: 20px;
  }
  
  .dialog-footer {
    text-align: right;
  }
}
</style>